module.exports = __webpack_public_path__ + "img/BC카드.967b8cf4.jpg";